<div class="form-section-block" *ngIf="contactData">
  <h2>{{ title }}</h2>
  <p>
    {{ contactData.salutation | salutationTitle | async }}
    {{ contactData.firstName }} {{ contactData.lastName }} {{ contactData.company }}
    {{ contactData.companyAddition || '' }}
    <br />
    {{ contactData.street }} {{ contactData.streetNo }}
    {{ contactData.streetNoAddition }}
    <br />
    {{ contactData.zipCode }} {{ contactData.city }}
  </p>
  <p>
    Telefon: {{ contactData.phone }}
    <br />
    E-Mail: {{ contactData.mail }}
  </p>
</div>
